import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { AdriverBannerId } from './Banners.constants';
import { BannerName } from './Banners.types';
import { dedupeAdriverBgBanner } from './AdriverBanner.helpers';
import { adjustBackgroundBannerOffset } from './Banners.helpers';

export function useBackgroundBanners() {
  const pathname = usePathname();
  const { isWebView } = useBridgeState();

  useEffect(() => {
    if (isWebView) return;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type !== 'childList') return;

        mutation.addedNodes.forEach(node => {
          if (
            !(node instanceof HTMLElement) ||
            (!node.classList.contains('lotriver-bg-left') &&
              !node.classList.contains('lotriver-bg-right'))
          ) {
            return;
          }

          const bannerElement = document.getElementById(
            AdriverBannerId[BannerName.Background]
          );

          if (!bannerElement) {
            node.remove();
            return;
          }

          if (!node.isConnected) return;

          dedupeAdriverBgBanner(node);
          adjustBackgroundBannerOffset();
        });
      });
    });

    let scrollRafId = 0;

    const handleResize = () => adjustBackgroundBannerOffset();

    const handleScroll = () => {
      if (scrollRafId) return;

      scrollRafId = window.requestAnimationFrame(() => {
        scrollRafId = 0;
        adjustBackgroundBannerOffset();
      });
    };

    observer.observe(document.body, {
      childList: true,
      subtree: false,
    });
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll, { passive: true });
    adjustBackgroundBannerOffset();

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);

      if (scrollRafId) window.cancelAnimationFrame(scrollRafId);
    };
  }, [pathname, isWebView]);
}
